<template>
    <highcharts :options="options.chart" ref="chart"></highcharts>
</template>

<script>
import {Chart} from 'highcharts-vue'
export default {
  data() {
    return {
      options: {
        stats: {},
        chart: {
          chart: {
            type: 'area',
          },
          title: {
            text: this.title
          },
          xAxis: {
            categories: this.categories,
          },
          yAxis: {
            title: {
              text: this.sideText
            }
          },
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr>' +
                '<td style="padding:0"><b>{point.y:.1f} Rs.</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            series: {
              label: {
                connectorAllowed: false
              }
            }
          },
          series: [{
            name: this.bottomText,
            data: this.data

          }],
          responsive: {
            rules: [{
              condition: {
                maxWidth: 200,
                maxHeight: 200
              },
              chartOptions: {
                legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom'
                }
              }
            }]
          },
          chartHeight: 200
        }
      },
    };
  },
  components: {
    highCharts: Chart,
  },
  props: {
    data: Array,
    categories: Array,
    sideText: String,
    bottomText: String,
    title: String,
    type: String,
  },
  watch: {
    data: {
      handler(val) {
        this.options.chart.series[0].data = val
      },
      deep: true,
      immediate: true
    },
    categories: {
      handler(val) {
        this.options.chart.xAxis.categories = val
      },
      deep: true,
      immediate: true
    },
  }
};
</script>

<style>

</style>
